module.exports = __webpack_public_path__ + "img/gendu.198e2a6e.png";